import React, { useState } from "react";
import "../components/BioGasBan.css";
import VID3 from "../images/videos/VIDEOS/VID3.mp4";

export default function BioGasBan() {

  const phone = "919597839564";

  const [showForm, setShowForm] = useState(false);
  const [org, setOrg] = useState("");
  const [address, setAddress] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [service, setService] = useState(""); // 🔥 SINGLE VALUE
  const [wasteType, setWasteType] = useState("");
  const [quantity, setQuantity] = useState("");
  const [message, setMessage] = useState("");

  const serviceOptions = [
    "Biogas Installation",
    "Biogas Service"
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!org || !mobile || !service) {
      alert("Please fill required fields");
      return;
    }

    const whatsappMessage = encodeURIComponent(
      `BIOGAS SYSTEM ENQUIRY\n\n` +
      `Organization: ${org}\n` +
      `Address: ${address}\n` +
      `Phone: ${mobile}\n` +
      `Email: ${email}\n\n` +
      `Required Service:\n• ${service}\n\n` +
      `Waste Type: ${wasteType}\n` +
      `Waste Quantity: ${quantity}\n\n` +
      `Additional Details:\n${message}`
    );

    window.open(`https://wa.me/${phone}?text=${whatsappMessage}`, "_blank");
  };

  return (
    <>
      {/* HERO */}
      <section className="hero">
        <video className="hero-video" src={VID3} autoPlay loop muted playsInline />
        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="title-box">
            <h1>BIO GAS</h1>
            <p>Turn organic waste into clean renewable energy ♻️🔥</p>

            <button className="quote-btn" onClick={() => setShowForm(true)}>
              Get Quote
            </button>
          </div>
        </div>
      </section>

      {/* FORM */}
      {showForm && (
        <div className="biogas-modal">
          <div className="biogas-form">
            <h2>Biogas Enquiry</h2>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Organization Name *"
                value={org}
                onChange={(e) => setOrg(e.target.value)}
              />

              <input
                type="text"
                placeholder="Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />

              <input
                type="tel"
                placeholder="Phone Number *"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />

              <input
                type="email"
                placeholder="Email ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              {/* CHECKBOX SECTION */}
              <div className="form-section">
                <p className="section-title">Biogas Requirement *</p>

                <div className="checkbox-group">
                  {serviceOptions.map((item, index) => (
                    <label key={index} className="checkbox-row">
                      <input
                        type="checkbox"
                        checked={service === item}
                        onChange={() => setService(item)}
                      />
                      <span className="checkbox-text">{item}</span>
                    </label>
                  ))}
                </div>
              </div>

              <input
                type="text"
                placeholder="Type of Waste (Food / Cow Dung / Poultry etc.)"
                value={wasteType}
                onChange={(e) => setWasteType(e.target.value)}
              />

              <input
                type="text"
                placeholder="Approx Waste Quantity (Kg / Day)"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />

              <textarea
                placeholder="Additional Requirement / Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <div className="form-actions">
                <button type="submit" className="send-btn">
                  Send via WhatsApp
                </button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setShowForm(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
